import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import CheckboxField from "../../../components/Fields/CheckboxField";
import CheckboxListField from "../../../components/Fields/CheckboxListField";
import NumberField from "../../../components/Fields/NumberField";
import SelectListField from "../../../components/Fields/SelectListField";
import TextareaField from "../../../components/Fields/TextareaField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FieldProps } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import WorkflowTaskTypeEnum from "../../../enums/WorkflowTaskTypeEnum";
import WorkflowTaskDefinitionModel from "../../../models/WorkflowTaskDefinitionModel";
import { WorkflowTaskDefinitionCreateModel } from "../Popups/Step_popup_AddTask";
import CodeTaskField from "./CodeTaskField";

export interface WorkflowTaskControlProps {
    getFieldProps: (fieldName: string) => FieldProps
    formData: WorkflowTaskDefinitionModel | WorkflowTaskDefinitionCreateModel
    workflowDefinitionId: number
}

const WorkflowTaskControl: React.FC<WorkflowTaskControlProps> = ({ getFieldProps, formData, workflowDefinitionId }) => {

    const taskTypes = useSelectListOptions('api/v1/selectlist/WorkflowTaskTypes', '-- Select task type');
    const taskCategories = useSelectListOptions('api/v1/selectlist/WorkflowTaskCategories', '-- Select task category');
    const workflowTaskStatusses = useSelectListOptions('api/v1/selectlist/WorkflowTaskStatuses', '-- Select status');
    const workflowRoles = useSelectListOptions('api/v1/selectlist/WorkflowRoles', '-- Select role');
    const codeTaskNames = useSelectListOptions('api/v1/selectlist/CodeTaskNames', '-- Select code task');
    const businessPartnerTypes = useSelectListOptions('api/v1/selectlist/BusinessPartnerTypes', '-- Select Business-partner type');
    const attachmentTypes = useSelectListOptions('api/v1/selectlist/AttachmentTypes', '-- Select Attachment type');
    const userDefinedfields = useSelectListOptions('api/v1/selectlist/UserDefinedfieldsForWorkflow?workflowDefinitionId=' + workflowDefinitionId);

    const infos = formData.codeTaskParameterInfos ?? []

    return ( 
        <Container fluid>
            <Row>
                <Col md='6'>
                    <TextboxField {...getFieldProps('name')} />
                    <NumberField {...getFieldProps('taskOrder')} />
                    <SelectListField {...getFieldProps('taskTypeId')} options={taskTypes} />
                    <SelectListField {...getFieldProps('taskCategoryId')} options={taskCategories} />
                    <SelectListField {...getFieldProps('initialTaskStatusId')} options={workflowTaskStatusses} />
                    <SelectListField {...getFieldProps('assignToFunctionalRoleId')} options={workflowRoles} />
                    <SelectListField {...getFieldProps('escalateToFunctionalRoleId')} options={workflowRoles} />
                    <CheckboxField {...getFieldProps('isRequired')} />
                    <CheckboxField {...getFieldProps('forwardsWorkflow')} />
                    <NumberField {...getFieldProps('duration')} />
                    <NumberField {...getFieldProps('reminderInterval')} />
                    <TextareaField {...getFieldProps('description')} rows={8} />
                </Col>
                <Col md='6'>
                    {formData.taskTypeId == WorkflowTaskTypeEnum.ExecuteCode && (
                        <>
                            <SelectListField {...getFieldProps('codeTaskName')} options={codeTaskNames} />
                            {infos.map((parInfo, index) =>
                                <CodeTaskField {...getFieldProps(`codeTaskParameterInfos.${index}.value`)} codeTaskParamterInfo={parInfo} key={parInfo.name} />
                            )}
                        </>
                    )}
                    {formData.taskTypeId == WorkflowTaskTypeEnum.AddBusinessPartner && <SelectListField {...getFieldProps('businessPartnerTypeId')} options={businessPartnerTypes} />}
                    {(formData.taskTypeId == WorkflowTaskTypeEnum.ReviseDocument ||
                        formData.taskTypeId == WorkflowTaskTypeEnum.AddDocument ||
                        formData.taskTypeId == WorkflowTaskTypeEnum.UpdateDocument) && (
                            <>
                                <SelectListField {...getFieldProps('attachmentTypeId')} options={attachmentTypes} />
                                <CheckboxField {...getFieldProps('attachmentRequired')} />
                            </>
                        )}
                    {(formData.taskTypeId == WorkflowTaskTypeEnum.SetCustomFields ||
                        formData.taskTypeId == WorkflowTaskTypeEnum.SetProjectItemCustomFields) && (
                            <>
                                <TextboxField {...getFieldProps('title')} />
                                <CheckboxListField {...getFieldProps('userDefinedFieldsIds')} options={userDefinedfields} layout='vertical' />
                            </>
                        )}
                </Col>

            </Row>
        </Container>
    )
}
export default WorkflowTaskControl;